module.exports = "/packs/media/digitalized_orders/euro-4860a6a5.png";